// extracted by mini-css-extract-plugin
export var cover = "header-live-search-styles-hs-module--cover--ce706";
export var dark = "header-live-search-styles-hs-module--dark--2a007";
export var headerLiveSearch = "header-live-search-styles-hs-module--header-live-search--1b347";
export var imageWrapper = "header-live-search-styles-hs-module--image-wrapper--e43aa";
export var inner = "header-live-search-styles-hs-module--inner--51ad6";
export var innerWithImage = "header-live-search-styles-hs-module--inner-with-image--3cf66";
export var keyDown = "header-live-search-styles-hs-module--key-down--2386a";
export var light = "header-live-search-styles-hs-module--light--7af3f";
export var liveSearch = "header-live-search-styles-hs-module--live-search--532f5";
export var liveSearchInput = "header-live-search-styles-hs-module--live-search-input--90083";
export var liveSearchResult = "header-live-search-styles-hs-module--live-search-result--33d34";
export var medium = "header-live-search-styles-hs-module--medium--d3a68";
export var slope = "header-live-search-styles-hs-module--slope--13ec8";
export var slopeWrapper = "header-live-search-styles-hs-module--slope-wrapper--8cdea";